export const FIELD_NAMES = {
  EMAIL: 'email',
  PASSWORD: 'password',
}
